<template>
  <g>
    <path
      d="M22.3582 11.1622C22.7935 11.1622 23.1465 11.5093 23.1465 11.9375V18.3631C23.1465 18.7912 22.7935 19.1383 22.3582 19.1383H21.0617V20.6681C21.0617 21.004 20.6571 21.1809 20.4035 20.9559L18.355 19.1383H12.9049C12.4696 19.1383 12.1166 18.7912 12.1166 18.3631V11.9375C12.1166 11.5093 12.4696 11.1622 12.9049 11.1622H22.3582Z"
      fill="#3E7DC0"
    />
    <path
      d="M2.16342 2.94366C1.44005 2.94366 0.853638 3.52038 0.853638 4.2318V14.9079C0.853638 15.6193 1.44005 16.196 2.16342 16.196H4.31745V18.7377C4.31745 19.2957 4.98976 19.5897 5.41102 19.2159L8.81469 16.196H17.87C18.5933 16.196 19.1797 15.6193 19.1797 14.9079V4.2318C19.1797 3.52038 18.5933 2.94366 17.8699 2.94366H2.16342Z"
      fill="white"
    />
    <path
      d="M2.16342 2.94366C1.44005 2.94366 0.853638 3.52038 0.853638 4.2318V14.9079C0.853638 15.6193 1.44005 16.196 2.16342 16.196H4.31745V18.7377C4.31745 19.2957 4.98976 19.5897 5.41102 19.2159L8.81469 16.196H17.87C18.5933 16.196 19.1797 15.6193 19.1797 14.9079V4.2318C19.1797 3.52038 18.5933 2.94366 17.8699 2.94366H2.16342Z"
      fill="url(#paint0_linear_939_1158)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.16342 3.44366C1.7083 3.44366 1.35364 3.80435 1.35364 4.2318V14.9079C1.35364 15.3353 1.7083 15.696 2.16342 15.696H4.81745V18.7377C4.81745 18.7962 4.84706 18.8421 4.90659 18.8681C4.96672 18.8944 5.02853 18.8869 5.07918 18.8419L8.62485 15.696H17.87C18.3251 15.696 18.6797 15.3353 18.6797 14.9079V4.2318C18.6797 3.80435 18.3251 3.44366 17.8699 3.44366H2.16342ZM0.353638 4.2318C0.353638 3.23641 1.1718 2.44366 2.16342 2.44366H17.8699C18.8616 2.44366 19.6797 3.23641 19.6797 4.2318V14.9079C19.6797 15.9032 18.8616 16.696 17.87 16.696H9.00453L5.74287 19.5899C5.0116 20.2388 3.81745 19.7436 3.81745 18.7377V16.696H2.16342C1.1718 16.696 0.353638 15.9032 0.353638 14.9079V4.2318Z"
      fill="#3E7DC0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.0261 6.34437C15.2058 6.55399 15.1816 6.86965 14.972 7.04941L8.75791 12.3786C8.57155 12.5385 8.29673 12.5393 8.10935 12.3807L5.06403 9.80268C4.85327 9.62426 4.82706 9.30876 5.00548 9.098C5.1839 8.88724 5.49939 8.86102 5.71016 9.03945L8.43031 11.3422L14.321 6.29033C14.5306 6.11056 14.8463 6.13476 15.0261 6.34437Z"
      fill="#3E7DC0"
    />
    <defs>
      <linearGradient
        id="paint0_linear_939_1158"
        x1="8.09168"
        y1="-1.59999"
        x2="8.09168"
        y2="19.3275"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#11AAE2" stop-opacity="0.25" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
    </defs>
  </g>
</template>
